import React, { useCallback, useEffect, useState } from "react";
import { UserCheck } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import AttendanceSheetDialog from "@/components/AttendanceSheetDialog";
import { fmtTime } from "@/components/PageHeader";
import api from "@/lib/api";

// "Attendance needed today" reminder for anyone allowed to take roll (coach or officer). Hides when nothing is pending.
export default function AttendanceTodayCard({ testId = "attendance-today-card" }) {
  const [pending, setPending] = useState([]);
  const [active, setActive] = useState(null);
  const load = useCallback(() => api.get("/attendance/today").then(({ data }) => setPending(data.pending || [])).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  if (pending.length === 0) return null;
  return (
    <Card className="mb-4 border-orange-200 bg-orange-50/50 p-5 shadow-sm animate-fade-in-up" data-testid={testId}>
      <div className="mb-3 flex items-center gap-2">
        <UserCheck className="h-4 w-4 text-orange-600" />
        <p className="text-xs font-bold uppercase tracking-wider text-orange-700">Attendance needed today</p>
      </div>
      <div className="space-y-2">
        {pending.map((e) => (
          <div key={e.id} className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-orange-100 bg-white p-3" data-testid={`attendance-pending-${e.id}`}>
            <div>
              <p className="text-sm font-semibold text-slate-800">{e.title}</p>
              <p className="text-xs text-slate-500">{e.all_day ? "All day" : (e.start_time ? fmtTime(e.start_time) : "Today")}</p>
            </div>
            <Button size="sm" className="rounded-full bg-slate-900 hover:bg-slate-800" onClick={() => setActive(e)} data-testid={`attendance-take-${e.id}`}>Take attendance</Button>
          </div>
        ))}
      </div>
      {active && <AttendanceSheetDialog event={active} open onClose={() => setActive(null)} onSaved={load} />}
    </Card>
  );
}
